import { CheckoutResponse } from "@/fetch/getCheckoutResponse";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type CheckoutSliceState = {
  setupComplete: boolean;
  checkoutCart: CheckoutCart | null;
  checkoutCartRetrievalState: "idle" | "pending";
  chosenCreditCard: string | null;
  chosenShippingAddress: number | null;
  checkoutReviewDetails: CheckoutResponse | null;
  placeOrderConfirmationDetails: CheckoutResponse | null;
  orderStatusError: string | null;
};
const initialState: CheckoutSliceState = {
  setupComplete: false,
  checkoutCart: null,
  checkoutCartRetrievalState: "idle",
  chosenCreditCard: null,
  chosenShippingAddress: null,
  checkoutReviewDetails: null,
  placeOrderConfirmationDetails: null,
  orderStatusError: null,
};
export const checkoutSlice = createSlice({
  name: "checkoutSlice",
  initialState,
  reducers: {
    setSetupComplete: (state, action: PayloadAction<boolean>) => {
      state.setupComplete = action.payload;
    },
    setShoppingCartCopy: (state, action) => {
      state.checkoutCart = action.payload;
    },
    setChosenCreditCard: (state, action: PayloadAction<string | null>) => {
      state.chosenCreditCard = action.payload;
    },
    setChosenShippingAddress: (state, action: PayloadAction<number | null>) => {
      state.chosenShippingAddress = action.payload;
    },
    setCheckoutReviewDetails: (state, action: PayloadAction<CheckoutResponse | null>) => {
      state.checkoutReviewDetails = action.payload;
    },
    setPlaceOrderConfirmationDetails: (state, action: PayloadAction<CheckoutResponse | null>) => {
      state.placeOrderConfirmationDetails = action.payload;
    },
    setOrderStatusError: (state: CheckoutSliceState, action: PayloadAction<string | null>) => {
      state.orderStatusError = action.payload;
    },
  },
  // extraReducers: (builder) => {
  // },
});

export const {
  setSetupComplete,
  setShoppingCartCopy,
  setChosenCreditCard,
  setChosenShippingAddress,
  setCheckoutReviewDetails,
  setPlaceOrderConfirmationDetails,
  setOrderStatusError,
} = checkoutSlice.actions;
export default checkoutSlice.reducer;

export type CheckoutCart = ShoppingCartState & {};
